import React from 'react';
import LinkWithParams from 'components/LinkWithParams/LinkWithParams';
import {trackClick} from 'utility/analytics';
import {openModal} from 'state/modals/actions';
import { HeroHeader } from './ServicesHero.styles.js';
import { XXL, LG } from '@zendeskgarden/react-typography';
import { Row, Col } from '@zendeskgarden/react-grid';
import {Button} from 'theme/Button';
import {get} from 'lodash';


const ServicesHero = (props) => {
  function goTorequest(data) {
    trackClick('inquire', 'Inquire About A Service', 'ServicesHero');
    openModal({
      type: 'inquireFormModal',
      data: {
        selectService: true,
        activeService: props.activeService
      }
    })
  }
  return (
      <HeroHeader>
        
        <div>
          <Row>
            <Col md={12}>
              {
                props.activeService ?
                <div>
                  <XXL style={{maxWidth: '1200px'}} bold paddingTopMd navy tag="h1">{props.activeService.title}</XXL>
                  <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                    {props.activeService.description}
                  </LG>
                </div> :

                <div>
                  <XXL style={{maxWidth: '1200px'}} bold paddingTopMd navy tag="h1">Faster Scanning, Clearer Images and Progressive, Dependable Equipment.</XXL>
                  <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                    Venders and Consumers alike call MRT when they want a job done right and when they can’t figure out what’s wrong! Simply put: <b className="black">we exceed expectations</b>.
                  </LG>

                  <LG style={{maxWidth: '1000px'}} paddingTopMd navy light tag="h3">
                    Masters of our trade, MRT will confidently provide you with the best quality reconditioned <LinkWithParams to="/c/equipment/mri">MRI</LinkWithParams>, <LinkWithParams to="/c/equipment/ct">CT</LinkWithParams>, <LinkWithParams to="/c/equipment/pet-ct">PET</LinkWithParams> equipment, <LinkWithParams to="/services/rf-shielding">shielding</LinkWithParams>, <LinkWithParams to="/services/ongoing-services">service</LinkWithParams>, <LinkWithParams to="/services/pre-install-planning">project management</LinkWithParams> and <LinkWithParams to="/services">more</LinkWithParams> in diagnostic Imaging.
                  </LG>
                </div>
              }
              

            </Col>
          </Row>
          <Row style={{marginTop: '30px'}}>
            <Col size={12} sm="auto">
              <Button onClick={goTorequest.bind(this, {service: props.activeService})} pairButton size="large" spacingBottom primary>{get(props, 'activeService.cta') || 'Inquire About A Service'}</Button>
            </Col>  
          </Row>
        </div>
      </HeroHeader>

  )
}


export default ServicesHero;
